import { render } from "./SzTreeSingle.vue?vue&type=template&id=34a226f0&scoped=true"
import script from "./SzTreeSingle.vue?vue&type=script&lang=ts"
export * from "./SzTreeSingle.vue?vue&type=script&lang=ts"

import "./SzTreeSingle.vue?vue&type=style&index=0&id=34a226f0&lang=less&scoped=true"
script.render = render
script.__scopeId = "data-v-34a226f0"

export default script